// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const debug: MarkdocFunctionSchema = {
  render(parameters): string {
    if (process.env.NODE_ENV === 'development') {
      const obj = parameters['0'];
      return JSON.stringify(obj, null, 2);
    } else {
      return '';
    }
  },
};
